module.exports = __webpack_public_path__ + "media/images/svg/menu-9021f8ab60bdd953fc8ded061fb18a61.svg";